import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom'

const LoginModal = (triggered) => {
  const [isOpen, setIsOpen] = useState(triggered);

  const login = useGoogleLogin({
    onSuccess: credentialResponse => {
      console.log('Login success:', credentialResponse);
      setIsOpen(false); // close modal after login success
    },
    onError: () => {
      console.log('Login Failed');
    }
  });
  
  const navigate = useNavigate();
  const returnToLoginPage = () => {
      navigate("/login");
  }

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <div>
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '2rem',
              borderRadius: '10px',
              textAlign: 'center',
              width: '400px'
            }}
          >
            <h6 className='m-2 '>Vous n'êtes pas connecté, ou votre session a expiré.</h6>
            <h4 className='mt-4 mb-4'>ASSIGANTO</h4>
            
            {/* Google styled button */}
            <button
              onClick={() => login()}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px',
                width: '100%',
                backgroundColor: 'white',
                border: '1px solid lightgray',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google Logo"
                style={{ width: '30px', marginRight: '10px' }}
              />
              Sign in with Google
            </button>
            <h6 className='mt-3'>ou</h6>
            <button
              onClick={() => returnToLoginPage()}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px',
                width: '100%',
                backgroundColor: '#2a95d1',
                border: '1px solid lightgray',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500',
                color: 'white'
              }}
            >
              Retour à la page de Connection
            </button>

            <br />

            <button
              onClick={closeModal}
              style={{
                marginTop: '1rem',
                backgroundColor: '#ccc',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginModal;